<script>export let hover = false;
export let active = false;
import { stateUi } from "@infinitro/config";
import { get } from "svelte/store";
let fill = "white";
$: fill = hover || active ? "var(--color-primary-500)" : "white";
$: chevronTransform = active ? "scaleX(1)" : "scaleX(-1)";
$: useAlternative2 = $stateUi.header.headerStyle === "alternative2";
</script>

{#if useAlternative2}
	{#if active}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3 6H12"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M3 12H15"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M3 18H12"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17 8L21 12L17 16"
				stroke="var(--color-primary-500)"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{:else}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3 6H17"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M3 12H13"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M3 18H17"
				stroke="white"
				stroke-opacity="0.5"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M21 8L17 12L21 16"
				stroke="var(--color-primary-500)"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{/if}
{:else}
	<svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.1667 3.33398H2.5V5.00065H14.1667V3.33398ZM14.1667 15.0007H2.5V16.6673H14.1667V15.0007Z"
			fill="white"
		/>
		<path d="M2.5 9.16708H10.8333V10.8337H2.5V9.16708Z" fill={'var(--color-primary-500)'} />
		<g style="transform: {chevronTransform};">
			<path
				d="M14.5032 6.16699L13.3247 7.34551L15.9763 9.99716L13.3247 12.6488L14.5032 13.8273L18.3333 9.99716L14.5032 6.16699Z"
				fill={'var(--color-primary-500)'}
			/>
		</g>
	</svg>
{/if}

<style>
	svg g {
		transition: transform 0.3s ease-in-out;
		transform-origin: center;
		transform-box: fill-box;
	}
</style>
